export default "__VITE_ASSET__fef916b1__"